import { render, staticRenderFns } from "./comp-full-screen.vue?vue&type=template&id=28047f92&scoped=true&lang=pug&"
import script from "./comp-full-screen.vue?vue&type=script&lang=js&"
export * from "./comp-full-screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28047f92",
  null
  
)

export default component.exports